"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 *
 * @param {String} country  = NZ or AU
 * @param {String} email - user email
 * @param {Object} billingInformation - address object from shipping form
 * used in ProfileActions
 * used in OrderActions
 *
 * GeneratePaymentDetails
 *
 * @returns BillingObject for api call
 */
var CreateBillingObject = function CreateBillingObject() {
  var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'NZ';
  var email = arguments.length > 1 ? arguments[1] : undefined;
  var billingInformation = arguments.length > 2 ? arguments[2] : undefined;
  var _billingInformation$a = billingInformation.addressType,
    addressType = _billingInformation$a === void 0 ? '' : _billingInformation$a,
    firstName = billingInformation.firstName,
    lastName = billingInformation.lastName,
    _billingInformation$c = billingInformation.companyName,
    companyName = _billingInformation$c === void 0 ? '' : _billingInformation$c,
    address1 = billingInformation.address1,
    _billingInformation$a2 = billingInformation.address2,
    address2 = _billingInformation$a2 === void 0 ? '' : _billingInformation$a2,
    _billingInformation$a3 = billingInformation.address3,
    address3 = _billingInformation$a3 === void 0 ? null : _billingInformation$a3,
    phoneNumber = billingInformation.phoneNumber,
    city = billingInformation.city,
    state = billingInformation.state,
    postalCode = billingInformation.postalCode,
    stateCode = billingInformation.stateCode;
  var finalAddressType = addressType ? addressType : companyName.length > 0 ? 'Commercial' : 'Residential';
  var billingObject = {
    contactInfo: {
      deliveryPhoneNumber: phoneNumber,
      email: email,
      companyName: companyName,
      dayPhoneNumber: phoneNumber
    },
    address: {
      address1: address1,
      address2: address2,
      address3: address3,
      city: city,
      country: country,
      postalCode: postalCode,
      type: country,
      addressType: finalAddressType
    },
    personalInfo: {
      salutation: '',
      firstName: firstName,
      lastName: lastName
    }
  };
  if (country === 'AU') {
    billingObject = _objectSpread(_objectSpread({}, billingObject), {}, {
      address: _objectSpread(_objectSpread({}, billingObject.address), {}, {
        state: stateCode,
        stateCode: stateCode
      })
    });
  }
  return billingObject;
};
var _default = exports["default"] = CreateBillingObject;